import { useActionState, useEffect } from "react";
import IconButton from "../../../../components/icon-button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { CharityEventType } from "../../../../models";
import { deleteCharityEventType } from "../actions";
import toast from "react-hot-toast";

export function DeleteCharityEventTypeButton({
  item,
  onChanged,
}: {
  item: CharityEventType;
  onChanged: () => void;
}) {
  const deleteWithId = deleteCharityEventType.bind(null, item.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteWithId, { success: false });

  useEffect(() => {
    if (!state.success) return;

    toast.success("Charity event type deleted successfully");
    onChanged();
  }, [state, onChanged]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
